import React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    SelectInput,
    ReferenceInput
} from 'react-admin';
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const AdminUrlCreate= () => {

    return (
        <Create>
            <SimpleForm>
                <TextInput name="path" source="path" validate={[required()]} fullWidth />
                <ReferenceInput
                    label="website"
                    source="website"
                    reference="websites"
                >
                    <SelectInput optionText="baseUrl"/>
                </ReferenceInput>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}